"use client"

import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"
import { Slot } from "@radix-ui/react-slot"
import { RemoveScroll } from "react-remove-scroll"

import { cn } from "@/lib/utils"
import { useInsideModalScrollLock } from "@/components/ui/modal-scroll-lock"

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => {
  const insideModal = useInsideModalScrollLock()
  return (
    <PopoverPrimitive.Portal>
      {/* A modal dialog's scroll lock (a blade's too) cancels wheel events outside its own
          content, and this content is portaled to the body, so inside one it holds its own,
          newest lock. noIsolation keeps the dialog body scrolling, and the scroll bar stays
          because the dialog already locks the page. Outside a modal dialog it stays off.
          react-remove-scroll must resolve to the same copy the Radix dialog uses: separate
          copies keep separate lock stacks. */}
      <RemoveScroll as={Slot} enabled={insideModal} noIsolation removeScrollBar={false} allowPinchZoom>
        <PopoverPrimitive.Content
          ref={ref}
          align={align}
          sideOffset={sideOffset}
          className={cn(
            "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
            className
          )}
          {...props}
        />
      </RemoveScroll>
    </PopoverPrimitive.Portal>
  )
})
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent }
